import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { AuthContext } from "../../context/auth.context";
import { AuthService } from "../../services";
import { Logo } from "../../assets/img";
import {
  MdOutlineMail,
  MdOutlineLock,
  MdVisibility,
  MdVisibilityOff,
  MdArrowForward,
} from "react-icons/md";

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { form, isLoading, onChange, onSubmit } = useForm();

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#F4F4F2] font-sans p-4">
      <div className="w-full max-w-[340px] min-h-[480px] bg-white px-6 pt-10 pb-10 rounded-2xl shadow-[0_4px_12px_rgba(0,0,0,0.06)] flex flex-col justify-between">
        <div>
          <img
            src={Logo}
            alt="Bórralo Logo"
            className="w-[90px] h-[90px] object-contain self-center mx-auto mb-2 bg-transparent"
          />

          <div className="flex flex-col items-center mb-6">
            <h1 className="text-[#1D3B8B] font-bold text-[22px] tracking-wide m-0">
              BÓRRALO
            </h1>
            <p className="text-[#6B7280] text-[13px] mt-0.5 m-0">
              Bórralo te lo compra!!
            </p>
          </div>
        </div>

        <form className="w-full" onSubmit={onSubmit}>
          <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-lg mb-4 h-11 px-3">
            <MdOutlineMail
              size={18}
              className="text-[#1D3B8B] mr-2.5 shrink-0"
            />
            <input
              type="email"
              placeholder="Correo electrónico"
              className="flex-1 bg-transparent border-none outline-none text-[13px] text-[#111827] placeholder-[#9CA3AF] h-full"
              value={form.email}
              onChange={(e) => onChange(e.target.value, "email")}
              autoCapitalize="none"
            />
          </div>

          <div className="flex flex-row items-center border border-[#F3F4F6] bg-[#FAFAFA] rounded-lg mb-4 h-11 px-3">
            <MdOutlineLock
              size={18}
              className="text-[#1D3B8B] mr-2.5 shrink-0"
            />
            <input
              type={isVisible ? "text" : "password"}
              placeholder="Contraseña"
              className="flex-1 bg-transparent border-none outline-none text-[13px] text-[#111827] placeholder-[#9CA3AF] h-full"
              value={form.password}
              onChange={(e) => onChange(e.target.value, "password")}
            />
            <button
              type="button"
              onClick={toggleVisibility}
              className="p-1 ml-1 bg-transparent border-none cursor-pointer flex items-center justify-center shrink-0"
            >
              {isVisible ? (
                <MdVisibility size={18} className="text-[#6B7280]" />
              ) : (
                <MdVisibilityOff size={18} className="text-[#6B7280]" />
              )}
            </button>
          </div>

          <div className="flex justify-center mb-6">
            <Link
              to="/recover"
              className="text-[#1D3B8B] font-medium text-[12px] no-underline"
            >
              Olvidé mi contraseña
            </Link>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#1D3B8B] rounded-lg h-11 flex flex-row justify-center items-center relative border-none cursor-pointer opacity-100 disabled:opacity-70 transition-opacity"
          >
            <span className="font-bold text-white text-[14px]">Acceder</span>
            <MdArrowForward size={18} className="text-white absolute right-4" />
          </button>
        </form>
      </div>
    </div>
  );
};

const useForm = () => {
  const { login } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [form, setForm] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (value, target) => {
    setForm((s) => ({ ...s, [target]: value }));
  };

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    };

    if (!form.email) return onError("Debe ingresar el correo");
    if (!form.password) return onError("Debe ingresar la contraseña");
    if (String(form.password).length < 6)
      return onError("La contraseña debe tener al menos 6 caracteres");

    return true;
  };

  const submit = async (event) => {
    event.preventDefault();
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const res = await AuthService.login(form);
      const userData = res?.user?.user || res?.user || res;
      const tokenData = res?.token || res?.user?.token || "";

      if (userData?.level_id !== 1) {
        AuthService.removeSession();
        toast.error("Acceso denegado: Solo administradores pueden ingresar");
        return;
      }

      login(userData);
      dispatch({ type: "SET_USER", payload: userData });
      dispatch({ type: "SET_JWT", payload: tokenData });
    } catch (error) {
      const errorMsg =
        typeof error === "string"
          ? error
          : error?.response?.data?.message ||
            error?.message ||
            "Error al iniciar sesión";
      toast.error(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return { form, isLoading, isValidForm, onChange, onSubmit: submit };
};

export default Login;
